/*
 * Picks dark or light variant. SVG paths live in GpLogoDark and
 * GpLogoLight.
 */
import React from 'react';
import GpLogoDark from './GpLogoDark';
import GpLogoLight from './GpLogoLight';

export { GpLogoDark, GpLogoLight };

export function GpLogo({ size = 28, variant = 'dark' }) {
  return variant === 'light' ? <GpLogoLight size={size} /> : <GpLogoDark size={size} />;
}

export default GpLogo;
